import {Component, Input} from '@angular/core';
import {WizardStep} from '@shared/models/wizard.model';

@Component({
  selector: 'si-pasi-wizard',
  templateUrl: './pasi-wizard.component.html',
  styleUrls: ['./pasi-wizard.component.scss']
})
export class PasiWizardComponent {
  @Input() steps: WizardStep[];
  @Input() currentStep: number;
}
